import { SearchQuery } from '@modules/feed/types';
import { parseStringifiedDuration } from '@modules/feed/utils/parseStringifiedDuration';

export const deserializeDuration = (val: string) => {
  const durationObject = JSON.parse(val) as SearchQuery['duration'];
  return parseStringifiedDuration(durationObject);
};
